import { useMutation } from '@tanstack/react-query'

import { useDeleteWarning } from './use-delete-warning'

import type { UseMutationOptions, MutateFunction } from '@tanstack/react-query'

function useDeleteWithWarning<
  TData = unknown,
  TError = unknown,
  TVariables = void,
  TContext = unknown
>(
  message: string,
  options: UseMutationOptions<TData, TError, TVariables, TContext>
) {
  const { showDeleteWarning } = useDeleteWarning()

  const { mutate, ...mutation } = useMutation(options)

  function mutationFn(
    ...[args, options]: Parameters<
      MutateFunction<TData, TError, TVariables, TContext>
    >
  ) {
    return showDeleteWarning(message, () => mutate(args, options))
  }

  return {
    ...mutation,
    mutate: mutationFn,
  }
}

export { useDeleteWithWarning }
